// ======================================================================
// File Name       : MessageValidate
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import PropTypes from 'prop-types';
import { ERROR_TYPE } from '../constants/index';

const getErrorClass = (errorType) => {
  switch (errorType) {
    case ERROR_TYPE.PRIMARY:
      return 'alert alert-info';
    case ERROR_TYPE.SUCCESS:
      return 'alert alert-success';
    case ERROR_TYPE.ERROR:
      return 'alert alert-danger';
    case ERROR_TYPE.WARNING:
      return 'alert alert-warning';
    case ERROR_TYPE.EMPTY:
      return 'alert alert-danger';
    default:
      return '';
  }
};

const MessageValidate = (props) => {
  const { errorMessage, errorType, visible } = props;
  return (
    <div>
      {visible &&
        <p className={getErrorClass(errorType)} style={{ marginTop: '2px', fontWeight: 'bold', paddingTop: '7px', paddingBottom: '7px', marginBottom: '7px' }}>
          {errorMessage}
        </p>}
    </div>
  );
};

MessageValidate.propTypes = {
  errorType: PropTypes.number.isRequired,
  visible: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
};

export default MessageValidate;
